<style scoped>
  #Abstract{
    padding-top: 40px;
    font-size: 16px;
    width:1190px;
    margin:0 auto;
  }
  #Abstract #wrap .top{
    position: relative;
    width:900px;
    margin:0 auto;
    overflow: hidden;

  }
  #Abstract #wrap .top ul{
    overflow: hidden;
    padding-bottom: 20px;
  }
  #Abstract #wrap .top ul .left{
    font-size: 20px;
    line-height: 20px;
  }
  #Abstract #wrap .top ul .right{
    overflow: hidden;
  }
  #Abstract #wrap .top ul .right div{
    float: left;
    padding-right: 30px;
  }
  #Abstract #wrap .top ul li{
    float: left;
    margin-right: 40px;
  }
  /*#file{*/
    /*position: absolute;*/
    /*bottom: 150px;*/
    /*left: 80px;*/
  /*}*/
  #file .list1{
    margin-left: -130px;
    overflow: hidden;
  }
  #file .list1 span,p,a{
    display: block;
    color:#000;
    float: left;
  }
  #file .list1 span{
    display: block;
    line-height: 40px;
    font-size: 20px;
  }
  #file .list1 p{
    margin-left: 20px;
    position: relative;
    width: 100px;
    height: 40px;
    background: #32B16c;
    text-align: center;
    line-height: 40px;
    color: #fff;
  }
  #file .list1 p input{
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top:0;
    left:0;
    opacity:0;


  }
  #file .list1 a{
    display: inline-block;
    padding-left: 50px;
    line-height: 40px;
  }
  #file .list2{
    margin-left: 20px;
    position: relative;
    width: 100px;
    height: 40px;
    background: #32B16c;
    text-align: center;
    line-height: 40px;
    color: #fff;
    margin-top: 40px;
    margin-left: 100px;
  }
  #btm{
    width: 200px;
    height:40px;
    background: #141651;
    color: #fff;
    text-align: center;
    line-height: 40px;
    margin: 0 auto;
    cursor: pointer;
    font-size: 16px;
  }
  #mid .ivu-form .ivu-form-item-label{
    font-size: 20px;
    color: #000;
    text-align: right;
  }

  #Abstract .ivu-radio-wrapper{
    font-size: 16px;
  }

</style>


<template>

<div id="Abstract">
  <div id="wrap">
    <div class="top">
      <ul>
        <li class="left">
          Presenting Type
        </li>
        <li class="right">
          <div v-for="(item,index) in radiotype">
            <input class="magic-radio" type="radio" :value="item" v-model="form" name="radio" :id="index" />
            <label :for="index">{{item}}</label>
          </div>
        </li>
      </ul>
      <div id="mid">

        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="165">

          <Form-item label="Topic" prop="Topic">
            <Select v-model="formValidate.Topic" placeholder="">
              <Option v-for="(item,index) in selecttype" :key="index" :value="item">{{item}}</Option>
            </Select>
          </Form-item>
          <Form-item label="Title" prop="Title">
            <Input  v-model="formValidate.Title" placeholder=""></Input>
          </Form-item>
          <Form-item label="Key Words" prop="keyword">
            <Input v-model="formValidate.keyword" placeholder=""></Input>
          </Form-item>



          <Form-item label="Content" prop="content">
            <Input  v-model="formValidate.content" type="textarea" :autosize="{minRows: 5}" placeholder=""></Input>
          </Form-item>
          <Form-item >
            <div id="file">

              <div class="list1"><span>Upload files</span><p >Choose file<input id="fileipt" @change="changeFile()"  type="file"/></p><p @click="addupdatepaper('formValidate')" style="cursor: pointer">Click to upload</p><a target="_blank" :href="filename.fileUrl">file name:{{filename.fileOrig}}</a></div>
              <div style="padding-left: 100px;padding-top: 20px;overflow: hidden">
                <p style="display: block;width: 100%" v-for="(item,index) in imgfile" :key="index"><a :href="item.url">{{item.name}}</a></p>
              </div>



            </div>
            <div id="btm" @click="next('formValidate')">Save and Next</div>
          </Form-item>
        </Form>
      </div>



    </div>
  </div>




    </div>
</template>

<script>
  import Bus from '@/bus'
  import check from 'magic-check/css/magic-check.css'
  import  'iview/src/styles/common/iconfont/fonts/ionicons.eot'
  import 'iview/src/styles/common/iconfont/fonts/ionicons.svg'
  import   'iview/src/styles/common/iconfont/fonts/ionicons.ttf'
  import   'iview/src/styles/common/iconfont/fonts/ionicons.woff'
    export default{
        data(){
            return {
              userStore:'',
              uid:'0',
              previewSrc:'',
              form:'Video',
              filename:{},
              imgfile:[],
              selecttype:[],
              radiotype:[],
              paperid:'',
              formValidate:{
                Topic:'',
                Title:'',
                keyword:'',
                content:'',
              },
              ruleValidate: {
                Title: [
                  { required: true, message: 'Please input title', trigger: 'blur' },
                ],
                keyword: [
                  { required: true, message: 'Please input key words', trigger: 'blur' },
                ],
                content: [
                  { required: true, message: 'Please input content', trigger: 'blur' },
//                  { type: 'string', min: 20, message: '介绍不能少于20字', trigger: 'blur' }
                ],
                Topic: [
                  { required: true, message: 'Please Choose your topic', trigger: 'change' }
                ],
              }
            }
        },
        mounted(){

           this.selectTopic();
          this.paperid=localStorage.getItem('paperId');
          this.userStore = JSON.parse(localStorage.getItem('user'));
          if(this.userStore === undefined || this.userStore === null){
            this.$Notice.warning({
              title: 'Please login first',
            });
          }else{
            this.uid=this.userStore.uId;
//            alert(this.uid)
            if(this.paperid!=0){
              this.addinfo()
            }
          }



        },
        methods: {
          //上传文件
          changeFile(){

            let file = document.getElementById('fileipt');
            let fileObj = file.files[0];
            let reader = new FileReader();
            reader.addEventListener("load", () => {
              this.previewSrc = reader.result;
            }, false);
            if (fileObj) {
              reader.readAsDataURL(fileObj);
            }

          },
          uploadImg: function() {

            if(this.previewSrc==''){
              this.$Notice.error({
                title: 'Please choose file',
              });
              return
            }
//            this.$Notice.success({
//              title: '正在上传',
//            });
            let formdata = new FormData();
            let filed = document.getElementById('fileipt').files[0];
            formdata.append('file', filed);
            let postUrl = '/medapp/api/common/file/1/'+this.paperid+'/'+this.uid ;
            this.postHttp(postUrl, formdata).then((result) => {
//              console.log(JSON.stringify(result.data));
              var data=result.data;

              if(data.code==0){
                  this.filename=data.files[0];
//                this.$Modal.success({
//                  title: "",
//                  content: "Successfully uploaded "
//                });
                this.$Modal.confirm({
                  title: '',
                  content: 'Successfully uploaded',
                  okText: 'OK',
                  cancelText: 'Cancel'
                });
              }else{
                console.log(data.code);
              }

            })
          },



          //添加作者列表调用接口
          addinfo(){
            var param = {
              'paperid':this.paperid,  //论文id   修改时候传入，添加为空
            }
            this.postHttp('/medapp/api/paper/getpapersinfo', param).then((result) => {
//                console.log(JSON.stringify(result.data));
              let  data=result.data;
              if (result.data.code == '0') {
                  for(var i=0; i<data.paper.files.length;i++){
                       this.imgfile.push({
                         name:data.paper.files[i].fileOrig,
                         url:data.paper.files[i].fileUrl
                       })
                  }

                this.form=data.paper.paperForm;
                this.formValidate.Topic=data.paper.paperType;
                this.formValidate.Title=data.paper.paperTitle;
                this.formValidate.keyword=data.paper.paperKeyword;
                this.formValidate.content=data.paper.paperSummary;


              } else{
                console.log(data.code)
              }

            })
          },
          //下拉列表
      selectTopic(){
        let param = {
            'cid':2006
        }

        this.postHttp('/medapp/api/paper/getdict', param).then((result) => {
//          console.log(JSON.stringify(result.data));
          let  data=result.data;
          if (result.data.code == '0') {
              for(let i=0;i<data.paper_form.length;i++){
                this.radiotype.push(data.paper_form[i]);
              }
            for(let j=0;j<data.paper_topics.length;j++){
              this.selecttype.push(data.paper_topics[j]);
            }

          } else{
          console.log(data.code)
          }


        });
      },
          //添加或修改文本基本信息
          addupdatepaper(){
//            Topic:'type1',
//              Title:'',
//              keyword:'',
//              content:'',

          },




          addupdatepaper(name){
            if (this.userStore === undefined || this.userStore === null) {
              this.$Notice.warning({
                title: 'Please login first',
              });
            } else {
            this.$refs[name].validate((valid) => {
              if (valid) {

                if (this.paperid == 0) {
                  var param = {
                    'paperid': '0',  //论文id   修改时候传入，添加为空
                    'cid': '2006',      //会议id
                    'form': this.form,     //交流方式
                    'type': this.formValidate.Topic,      //topic类型
                    'title': this.formValidate.Title,     //标题
                    'keyword': this.formValidate.keyword,     //关键词
                    'summary': this.formValidate.content,    //摘要
                    'language': ' en',    //中文英文   英文en  中文 cn
                    'uid': this.uid   //用户id
                  }
                } else {
                  var param = {
                    'paperid': this.paperid,  //论文id   修改时候传入，添加为空
                    'cid': '2006',      //会议id
                    'form': this.form,     //交流方式
                    'type': this.formValidate.Topic,      //topic类型
                    'title': this.formValidate.Title,     //标题
                    'keyword': this.formValidate.keyword,      //关键词
                    'summary': this.formValidate.content,    //摘要
                    'language': ' en',    //中文英文   英文en  中文 cn
                    'uid': this.uid   //用户id
                  }
                }
                this.postHttp('/medapp/api/paper/addorupdatepaper', param).then((result) => {
//                  console.log(JSON.stringify(result.data));
                  let data = result.data;
                  if (result.data.code == '0') {

                    localStorage.setItem('paperId', data.paper.paperId)
                    this.paperid = data.paper.paperId;
                    this.uploadImg();
                    if (this.paperId != 0) {
                      this.form = data.paper.paperForm;
                      this.formValidate.Topic = data.paper.paperType;
                      this.formValidate.Title = data.paper.paperTitle;
                      this.formValidate.keyword = data.paper.paperKeyword;
                      this.formValidate.content = data.paper.paperSummary;

                    }

//                    this.$Message.success('提交成功!');

                  } else {
                    console.log(data.code)
//                    this.$Message.error('提交失败!');
                  }


                });

              } else {
//                this.$Message.error('Please !');
              }
            })
          }


          },
          next(name){
            if (this.userStore === undefined || this.userStore === null) {
              this.$Notice.warning({
                title: 'Please login first',
              });
            } else {
            this.$refs[name].validate((valid) => {
              if (valid) {

                if (this.paperid == 0) {
                  var param = {
                    'paperid': '0',  //论文id   修改时候传入，添加为空
                    'cid': '2006',      //会议id
                    'form': this.form,     //交流方式
                    'type': this.formValidate.Topic,      //topic类型
                    'title': this.formValidate.Title,     //标题
                    'keyword': this.formValidate.keyword,     //关键词
                    'summary': this.formValidate.content,    //摘要
                    'language': ' en',    //中文英文   英文en  中文 cn
                    'uid': this.uid   //用户id
                  }
                } else {
                  var param = {
                    'paperid': this.paperid,  //论文id   修改时候传入，添加为空
                    'cid': '2006',      //会议id
                    'form': this.form,     //交流方式
                    'type': this.formValidate.Topic,      //topic类型
                    'title': this.formValidate.Title,     //标题
                    'keyword': this.formValidate.keyword,      //关键词
                    'summary': this.formValidate.content,    //摘要
                    'language': ' en',    //中文英文   英文en  中文 cn
                    'uid': this.uid   //用户id
                  }
                }
                this.postHttp('/medapp/api/paper/addorupdatepaper', param).then((result) => {
//                  console.log(JSON.stringify(result.data));
                  let data = result.data;
                  if (result.data.code == '0') {

                    localStorage.setItem('paperId', data.paper.paperId)
                    this.paperid = data.paper.paperId;
                    if (this.paperId != 0) {
                      this.form = data.paper.paperForm;
                      this.formValidate.Topic = data.paper.paperType;
                      this.formValidate.Title = data.paper.paperTitle;
                      this.formValidate.keyword = data.paper.paperKeyword;
                      this.formValidate.content = data.paper.paperSummary;

                    }

                    Bus.$emit('button', 2);
                    this.$router.push('/home_en/2006/submit/Author')

                  } else {
                    console.log(data.code)
//                    this.$Message.error('提交失败!');
                  }


                });

              } else {
//                this.$Message.error('请先完善个人信息!');
              }
            })
          }


          }

        },




    }

</script>



// WEBPACK FOOTER //
// Abstract.vue?6ec06d7c